import React, { useState } from 'react'
import { Collapse } from 'react-bootstrap'
import { getI18nText } from '../../services/i18nService'

const P65 = ({ microcopy }) => {
  const [isOpen, setIsOpen] = useState(true)

  return (
    <div className="row">
      <div className="col accordion-full">
        <div className="product-details__product-data--item" id="legislationandcompliance">
          <p
            className="product-details__product-data--header font__heavy"
            id="button-legislationandcompliance"
          >
            <button
              className={`product-details__product-data--button ${isOpen ? '' : 'collapsed'}`}
              type="button"
              aria-expanded={isOpen}
              onClick={() => setIsOpen(!isOpen)}
              aria-controls="legislationandcompliance"
            >
              {getI18nText(microcopy, 'product.legislationandcompliance')}
            </button>
          </p>
          <Collapse in={isOpen}>
            <div
              id="body-legislation"
              className="product-details__product-data--collapse"
              aria-labelledby="button-legislation"
            >
              <div className="product-details__product-data--body">
                <p>{getI18nText(microcopy, 'product.p65intro')}</p>
                <p className="is-warningbox no-background mt-5 ps-0">
                  <img
                    src="../../../assets/images/Warning.svg"
                    alt=""
                    className="configurators__warning me-3 my-0"
                  />
                  <span>
                    <span className="font__bold">{getI18nText(microcopy, 'product.warning')}:</span>{' '}
                    {getI18nText(microcopy, 'product.cancerandreproductiveharm')} -&nbsp;
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={getI18nText(microcopy, 'product.p65url')}
                    >
                      {getI18nText(microcopy, 'product.p65url')}
                    </a>
                  </span>
                </p>
              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </div>
  )
}

export default P65
